import {useCallback} from 'react';
import {getNorafUpdatesIgnorelist} from 'api/agentNoraf';
import {useGetTokens} from 'services/auth';

export const useGetNorafUpdatesIgnorelist = () => {
  const getTokens = useGetTokens();

  return useCallback(
    (mock?: boolean) => {
      return getNorafUpdatesIgnorelist(getTokens, mock);
    },
    [getTokens],
  );
};
